import { App } from "antd";
import { useMutation } from "@tanstack/react-query";
import api from "../../utils/api";

interface UploadScholarshipFormPayload {
  scholarship: File;
}

const uploadScholarshipForm = async (payload: FormData) => {
  return (
    await api.post("/scholarship/upload", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  ).data as Response;
};

export const useUploadScholarshipFormMutation = () => {
  const { notification } = App.useApp();

  const mutation = useMutation({
    mutationFn: uploadScholarshipForm,
  });

  const uploadScholarshipFormHandler = async ({
    scholarship,
  }: UploadScholarshipFormPayload) => {
    const formData = new FormData();
    formData.append("scholarship", scholarship);

    try {
      const response = await mutation.mutateAsync(formData);

      notification.success({
        message: "Success",
        description: response?.message || "Scholarship form uploaded successfully",
      });

      return response;
    } catch (error: any) {
      notification.error({
        message: "Error",
        description:
          error?.response?.data?.message || "Failed to upload scholarship form",
      });
      throw error;
    }
  };

  return {
    ...mutation,
    uploadScholarshipForm: uploadScholarshipFormHandler,
    isLoading: mutation.isPending,
  };
};

export default useUploadScholarshipFormMutation;